import { CandidateLocation } from "./candidate-location";

export class Candidate {
    email: string;
    name: string;
    resumeUrl: string;
    phoneNumber: string;
    location: CandidateLocation;
}
